angular
.module('vppApp')
.service('VehicleDetailService', VehicleDetailService);

VehicleDetailService.$inject = []; 

function VehicleDetailService() {
	var VehicleDetailService = {};

	VehicleDetailService.setVehicleDetailVin = function (vin) {
		// sets sessionStorage data
		window.sessionStorage.setItem("vehicleTagDetail", vin);
	};
	
	VehicleDetailService.destroyVehicleDetailVin = function () {
		// sets sessionStorage data
		window.sessionStorage.removeItem("vehicleTagDetail");
	};
	
	VehicleDetailService.getVehicleDetailVin = function () {
		// sets sessionStorage data
		var vin = window.sessionStorage.getItem("vehicleTagDetail");
		return (vin || '');
	};
	
	VehicleDetailService.setSearchCriteria = function(options) {
		window.sessionStorage.setItem("tagSearchCriteria", JSON.stringify(options || {}));
	};
	
	VehicleDetailService.getSearchCriteria = function() {
		try {
			var search = window.sessionStorage.getItem("tagSearchCriteria");
			return (JSON.parse(search || '{}'));
		} catch(e) {
			return {};
		}
	};
	
	VehicleDetailService.toURLQuery = function(options) {
		var string = '';
		Object.keys(options || {}).forEach(function(element) {
			var val = options[element];
			var amp = string ? '&' : '';
			string += val ? (amp + element + '=' + val) : '';
		});
		return string ? ('?' + string) : '';
	};
	
	return VehicleDetailService;
};
